import { render } from "./ProgressCircle.vue?vue&type=template&id=560d4f65&scoped=true"
import script from "./ProgressCircle.vue?vue&type=script&lang=js"
export * from "./ProgressCircle.vue?vue&type=script&lang=js"

import "./ProgressCircle.vue?vue&type=style&index=0&id=560d4f65&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560d4f65"]])

export default __exports__